import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
  DEFAULT_MAX_SVG_HEIGHT,
  DEFAULT_MIN_SVG_WIDTH,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { EnhancedButton } from '@ui/enhanced-components/enhanced-components'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import clsx from 'clsx'
import { graphql } from 'gatsby'
import React from 'react'

const assetOptions: AssetOptionsContextProps = {
  width: 'auto',
  height: 'auto',
  minSvgWidth: DEFAULT_MIN_SVG_WIDTH,
  maxSvgHeight: DEFAULT_MAX_SVG_HEIGHT,
  objectFit: 'contain',
  alt: '',
  display: 'inline',
}

const ContentfulContentArticleRefreshImageFull: Utils.EntryFC<
  Queries.ContentfulContentArticleRefreshImageFullFragment
> = ({
  content: { image, contentLinkText, contentLinkUrl },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const hasImage = Boolean(image)
  const hasFooterLink = contentLinkText && contentLinkUrl

  return (
    <div
      className="flex h-full w-full flex-col items-center"
      {...entryInspectorProps()}
    >
      {hasFooterLink && (
        <div className={clsx(hasImage && 'pb-12')}>
          <EnhancedButton
            className="!border-theme-primary-accent3 !bg-theme-primary-accent3 hover:!border-theme-primary-accent4 hover:!bg-theme-primary-accent4"
            data-role={ENHANCED_COMPONENT_ROLE.SECONDARY}
            data-type={ENHANCED_COMPONENT_TYPE.CTA}
            href={contentLinkUrl}
            {...fieldInspectorProps({
              fieldId: 'contentLinkText',
            })}
          >
            {contentLinkText}
          </EnhancedButton>
        </div>
      )}
      {hasImage && (
        <div className="relative w-full">
          <div className="h-[310px] laptop:h-[330px]" />
          <div
            className="absolute -bottom-[72px] left-0 right-0 m-auto text-center laptop:-bottom-[120px]"
            {...fieldInspectorProps({
              fieldId: 'image',
            })}
          >
            <AssetOptionsContext.Provider value={assetOptions}>
              <Entry
                content={image}
                mapping={{
                  [ContentType.ContentfulAsset]: ContentfulAsset,
                }}
              />
            </AssetOptionsContext.Provider>
          </div>
        </div>
      )}
    </div>
  )
}

export const query = graphql`
  fragment ContentfulContentArticleRefreshImageFull on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    image {
      ...ContentfulDefaultAsset
    }
    contentLinkText
    contentLinkUrl
  }
`

export default withDisplayName(
  ContentfulContentArticleRefreshImageFull,
  'ContentfulContentArticleRefreshImageFull'
)
